/**
 * Códigos de erro de COMUNICADO (informativo) que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const ANNOUNCEMENT_ERRORS = {
  /** 404 — comunicado não é da empresa de quem pediu, ou não existe (#4481). */
  NOT_FOUND: "ERR_NO_ANNOUNCEMENT_FOUND",
} as const;

export type AnnouncementErrorCode =
  (typeof ANNOUNCEMENT_ERRORS)[keyof typeof ANNOUNCEMENT_ERRORS];
